<template>
  <v-avatar
      v-if="user.profile"
      :class="{'change-cursor': canRouteToProfile}"
      :color="color"
      :size="size"
      :style="styles"
      class="mt-1"
      @click="goToMentorProfile()"
  >
    <img
        v-if="user.profile.avatar"
        :src="user.profile.avatar"
        alt="user avatar"
    />
    <span v-else :class="`white--text ${avatarClasses}`">
      {{ user.email.charAt(0).toUpperCase() }}
    </span>
  </v-avatar>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    user: {
      type: Object,
      default: () => ({profile: {}, email: "", uuid: ""})
    },
    size: {
      type: String,
      default: () => "30"
    },
    color: {
      type: String,
      default: () => "primary"
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    canRouteToProfile: {
      type: Boolean,
      default: false
    },
    avatarClasses: {
      type: String,
      default: () => 'text-h5'
    }
  },
  methods: {
    goToMentorProfile() {
      if (this.canRouteToProfile) this.$router.push(`/mentors/${this.user.uuid}`)
    }
  }
}
</script>

<style scoped>
.change-cursor {
  cursor: pointer !important;
}
</style>
